import { createContext, useContext, type FC, type ReactNode } from 'react';

/**
 * Управление, стоящее в шапке диаграммы рядом с её названием, — переключатель разреза.
 *
 * Идёт контекстом, а не пропом: шапку рисует карточка внутри представления типа, и проп прошёл бы
 * через все десять представлений, ни одному из которых разрез не нужен.
 */
const ChartCardHeaderContext = createContext<ReactNode>(null);

type Props = {
  /** Управление шапки; `null` — диаграмма показана одним названием */
  action: ReactNode;
  children: ReactNode;
};

/** Задаёт управление шапки диаграммам, отрисованным внутри. */
export const ChartCardHeaderProvider: FC<Props> = ({ action, children }) => (
  <ChartCardHeaderContext.Provider value={action}>{children}</ChartCardHeaderContext.Provider>
);

/** Управление шапки текущей диаграммы; `null` — его нет. */
export const useChartCardHeaderAction = (): ReactNode => useContext(ChartCardHeaderContext);
